import { useQuery, keepPreviousData } from "@tanstack/react-query";
import drEasyApi from "../Api/Customapi";

export const servicesStatsKeys = {
  all: ["services-stats"],
  list: (params) => ["services-stats", params],
};

// Drops empty values so we don't send ?SearchTerm=&IsActive= to the API.
const clean = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );

export const fetchServicesStats  = async (params) => {
  const res = await drEasyApi.get("/api/Services/GetWithStats", { params: clean(params) });
  // Response is wrapped: { statusCode, isSuccessStatusCode, message, data: {...} }
  if (res.data?.isSuccessStatusCode === false) {
    throw new Error(res.data?.message || "Failed to load services");
  }
  return res.data.data;
};

export const useServicesStats = (params) =>
  useQuery({
    queryKey: servicesStatsKeys.list(params),
    queryFn: () => fetchServicesStats(params),
    placeholderData: keepPreviousData,
    staleTime: 60 * 1000,
  });